import script from "./MazdaLegacyRedisPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaLegacyRedisPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaLegacyRedisPanel.vue?vue&type=style&index=0&id=01069e3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01069e3d"]])

export default __exports__